import { FullListingRecord } from './FullListing';
import { instanceToPlain } from 'class-transformer';
import { RepliersListing } from './repliers/RepliersListing';
import { convertLotMeasurementsToMetres } from '../helpers/repliersData/convertLotMeasurementsToMetres';

export type ListingLotObject = {
  depth: number | null;
  width: number | null;
  irregular: string | null;
  acres: string | null;
  legalDescription: string | null;
};

export type ListingLotRecord = {
  lotDepth: number | null;
  lotWidth: number | null;
  lotDetails: {
    irregular: string | null;
    acres: string | null;
    legalDescription: string | null;
  };
};

export class ListingLot {
  depth: number | null; // always stored in metres
  width: number | null; // always stored in metres
  irregular: string | null; // eg: 'As per Survey'
  acres: string | null; // eg: '< .50' or '2-4.99'
  legalDescription: string | null; // eg: 'Plan M64, Lot 42'

  constructor({
    depth,
    width,
    irregular,
    acres,
    legalDescription,
  }: ListingLotObject) {
    this.depth = depth;
    this.width = width;
    this.irregular = irregular;
    this.acres = acres;
    this.legalDescription = legalDescription;
  }

  static fromObject(listingLotObject: ListingLotObject): ListingLot {
    return new ListingLot(listingLotObject);
  }

  static fromListingRecord(
    listingRecord: Pick<
      FullListingRecord,
      'lotDetails' | 'lotDepth' | 'lotWidth'
    >,
  ): ListingLot {
    return new ListingLot({
      ...listingRecord.lotDetails,
      depth: listingRecord.lotDepth,
      width: listingRecord.lotWidth,
    });
  }

  static fromRepliersListing(repliersListing: RepliersListing): ListingLot {
    return new ListingLot({
      acres: repliersListing.lot.acres,
      legalDescription: repliersListing.lot.legalDescription,
      irregular: repliersListing.lot.irregular,
      depth: convertLotMeasurementsToMetres(
        repliersListing.lot.depth,
        repliersListing.lot.measurement,
        repliersListing.mlsNumber,
      ),
      width: convertLotMeasurementsToMetres(
        repliersListing.lot.width,
        repliersListing.lot.measurement,
        repliersListing.mlsNumber,
      ),
    });
  }

  toListingLotRecord(): ListingLotRecord {
    return {
      lotDepth: this.depth,
      lotWidth: this.width,
      lotDetails: {
        irregular: this.irregular,
        acres: this.acres,
        legalDescription: this.legalDescription,
      },
    };
  }

  toObject(): ListingLotObject {
    return instanceToPlain(this) as ListingLotObject;
  }
}
